import store from 'store2';
import { KEY_STORE_LOGGER, Level } from './LoggerConstants';
import { AppenderData, LogLevel } from './Interfaces';

interface LoggerInfo {
  id?: string;
  rootLevel?: LogLevel<Level>;
  appenderData?: AppenderData[];
}

export function getStoredLoggerInfo(): LoggerInfo {
  return store(KEY_STORE_LOGGER);
}
export function saveStoredLoggerInfo(options: LoggerInfo): void {
  store(KEY_STORE_LOGGER, options);
}
